import { lazy } from "react";
import { isChunkError, maybeReloadForChunk } from "@/lib/report";

// Drop-in replacement for React.lazy that survives transient network blips and
// stale code-split chunks after a redeploy: retry once, then (for a true chunk
// error) silently reload the app to fetch the fresh index + chunk hashes.
export function lazyWithRetry(factory) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem("kairos-chunk-reload"); // healthy load → allow future auto-recovery
      return mod;
    } catch (e) {
      // A true chunk error won't be fixed by re-requesting the same missing URL — recover now.
      if (isChunkError(e) && maybeReloadForChunk()) return new Promise(() => {});
      // Otherwise treat as a transient blip: retry once after a short delay.
      await new Promise((r) => setTimeout(r, 500));
      try {
        return await factory();
      } catch (e2) {
        if (isChunkError(e2) && maybeReloadForChunk()) {
          return new Promise(() => {}); // hang until the reload takes over
        }
        throw e2;
      }
    }
  });
}
